(function () {
  if (window.__ctrTryOnceButtonInit) return;
  window.__ctrTryOnceButtonInit = true;

  function formatPriceFromCents(cents) {
    var valueInCents = Math.round(Number(cents) || 0);
    var moneyFormat =
      (window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.moneyFormat) ||
      '${{amount}}';

    if (window.FoxTheme && window.FoxTheme.Currency && typeof window.FoxTheme.Currency.formatMoney === 'function') {
      return window.FoxTheme.Currency.formatMoney(valueInCents, moneyFormat);
    }

    return (valueInCents / 100).toFixed(2);
  }

  async function addTryOnceItem(variantId, triggerButton) {
    if (!variantId) return;

    var item = {
      id: Number(variantId),
      quantity: 1
    };

    try {
      triggerButton.setAttribute('aria-disabled', 'true');
      triggerButton.classList.add('is-loading');

      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [item],
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        var error = await response.json();
        alert(error.description || 'Error adding to cart.');
        return;
      }

      var parsedState = await response.json();
      var cartResponse = await fetch('/cart.js', FoxTheme.utils.fetchConfig());
      var cartJson = await cartResponse.json();
      cartJson.sections = parsedState.sections;
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.show(triggerButton);
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      console.error('CTR try once button error:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      triggerButton.removeAttribute('aria-disabled');
      triggerButton.classList.remove('is-loading');
    }
  }

  function initCtrTryOnceButtons(scope) {
    var root = scope || document;
    var wrappers = root.querySelectorAll('[data-ctr-try-once]');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.ctrTryOnceInit === 'true') return;
      if (wrapper.closest('[data-ctr-buy-box]')) return; // handled by ctr-sub-buy-box.js

      var tryButton = wrapper.querySelector('[data-ctr-try-btn]');
      var tryPrice = wrapper.querySelector('[data-ctr-try-price]');
      if (!tryButton) return;

      var blocksRoot = wrapper.closest('.product__blocks');
      var simpleButton = blocksRoot
        ? blocksRoot.querySelector('[data-ctr-button-mode="simple"][data-ctr-subscribe-btn]')
        : null;

      var variantId = wrapper.getAttribute('data-ctr-try-variant-id');
      if (!variantId && simpleButton) variantId = simpleButton.getAttribute('data-variant-id');

      var oneTimePriceCents = wrapper.getAttribute('data-ctr-try-onetime-price-cents');
      if (simpleButton && simpleButton.getAttribute('data-onetime-price-cents')) {
        oneTimePriceCents = simpleButton.getAttribute('data-onetime-price-cents');
      }

      if (tryPrice) {
        tryPrice.textContent = formatPriceFromCents(oneTimePriceCents);
      }

      tryButton.addEventListener('click', function (event) {
        event.preventDefault();
        addTryOnceItem(variantId, tryButton);
      });

      wrapper.dataset.ctrTryOnceInit = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCtrTryOnceButtons(document);
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initCtrTryOnceButtons(event.target);
    });
  }
})();
